import { createSlice } from "@reduxjs/toolkit";

export const feedbackSlice = createSlice({
    name: "feedback",
    initialState: {
        feedbacks: [],
        loading: false,
        error: null,
    },
    reducers: {
        setLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        setFeedbacks: (state, action) => {
            state.loading = false;
            state.error = null;
            state.feedbacks = action.payload.data;
        },
        setError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
})

export const {
    setLoading,
    setFeedbacks,
    setError,
} = feedbackSlice.actions;

export default feedbackSlice.reducer;
